import { useParams, useLocation } from "react-router";  
import Query from "../common/Query";
import PAGEBYSLUG_QUERY from "./queries/PAGEBYSLUG_QUERY";
import PageItem from "./components/PageItem";
import Page from "./types/Page";
import { hasAdminRole } from "../utils";
import JoinCTA from "../common/JoinCTA";
import VolunteerCTA from "../common/VolunteerCTA";
import useEmulatedLookupID from "../hooks/useEmulatedLookupID";
import useOrgInfoLookupID from "../hooks/useOrgInfoLookupID";
import useOrgInfoVolunteerAccess from "../hooks/useOrgInfoVolunteerAccess";
import useOrgRoles from "../hooks/useOrgRoles"

const PageItemView = () => {  
  let { slug }: {slug?: string} = useParams();
  const emulatedLookupID = useEmulatedLookupID()
  const orgInfoLookupID = useOrgInfoLookupID()
  const lookupId = emulatedLookupID || orgInfoLookupID;
  const orgRoles = useOrgRoles();
  const isAdmin = hasAdminRole(orgRoles);
  const isVolunteer = useOrgInfoVolunteerAccess();
  let location = useLocation();
  let preview = isAdmin ? new URLSearchParams(location.search).get('preview'): false;
  
  if (!lookupId && !isAdmin) {
    return <JoinCTA/>
  } else if(!isVolunteer && !isAdmin) {
    return <VolunteerCTA/>
  }
  
  return <Query query={PAGEBYSLUG_QUERY} variables={{slug: slug, published: !preview}}>{ ( { data: { pageBySlug } }: {data: { pageBySlug: Page}}) => {
        return (
          pageBySlug ? <PageItem page={pageBySlug} /> : <div><h3>Not Found</h3></div>
        );
      }}
    </Query>;
};

export default PageItemView; 